<template>
  <div id="registration-fee">
    <div v-if="!showCompletedEnrollment">
      <div class="row row-large">
        <div class="col-grid-2">
          <div>
            <div class="row row-large">
              <div class="row row-small">
                <form-field :id="'name'" :label="''" required>
                  <input
                    type="text"
                    id="name"
                    @input="validate(['name'])"
                    placeholder="Nombre en tarjeta"
                    v-model="validations.name.value"
                    :class="{
                      'lcu-enroll-inputError': validations.name.errors.length > 0,
                    }"
                    class="lcu-enroll-inputText lcu-stripe-input" />
                </form-field>
              </div>
              <div class="row row-small" v-if="validations.name.errors.length > 0">
                <span class="lcu-enroll-errorMsg">
                  {{ validations.name.errors.join(' ') }}
                </span>
              </div>
            </div>
            <div class="row row-large">
              <spin-loader
                v-if="stripeLoading"
                :color="'#333'"
                :tiny="true" />
              <div class="row row-large" v-show="!stripeLoading">
                <div class="stripe-card-section">
                  <div id="card-element" class="stripe-card-input"></div>
                  <div id="card-errors" class="stripe-error-message"></div>
                </div>
              </div>
            </div>
            <div class="row row-large">
              <form-field
                :id="'save-payment'"
                :sideLabel="true"
                :label="'Guardar Método de Pago'">
                <input
                  type="checkbox"
                  name="save-payment"
                  id="save-payment"
                  v-model="savePaymentMethod"
                  class="lcu-form-checkbox" />
              </form-field>
            </div>
          </div>
          <div class="lcu-summary-box">
            <div class="row">
              <div class="lcu-summary-item">
                <img
                  src="/assets/default-course-logo.png"
                  class="lcu-summary-itemImage" />
                <div>
                  <p>Cuota única de inscripción</p>
                  <strong class="lcu-fee-price">
                    {{ pricing.subtotal }} ({{ pricing.currency }})
                  </strong>
                </div>
              </div>
            </div>
            <div class="row">
              <hr class="line-break"/>
            </div>
            <div class="row">
              <div class="lcu-discount-input">
                <form-field :id="'discount'" :label="''">
                  <input
                    type="text"
                    id="discount"
                    v-model="discount"
                    @input="validateDiscount"
                    :readonly="discountApplied"
                    placeholder="Código de descuento"
                    :class="{
                      'lcu-register-inputError': discountError,
                      'lcu-disabled-input': discountApplied
                    }"
                    class="lcu-form-inputText lcu-input-discount" />
                </form-field>
                <button-cta
                  :text="!discountApplied ? 'Aplicar' : 'Limpiar'"
                  :type="'primary-light'"
                  :loading="discountLoader"
                  :disabled="discountLoader"
                  @on-click="!discountApplied ? onApplyDiscount() : clearDiscount()" />
              </div>
              <div class="row row-small" v-if="discountError">
                <span class="lcu-discount-errorMsg">
                  {{ discountError }}
                </span>
              </div>
            </div>
            <div class="row">
              <hr class="line-break"/>
            </div>
            <div class="row">
              <div class="lcu-summary-totals">
                <span>Subtotal: </span>
                <span>{{ pricing.subtotal }}</span>
                <span
                  class="lcu-summary-savings"
                  v-if="savings">Savings:</span>
                <span
                  class="lcu-summary-savings"
                  v-if="savings">- {{ savings }}</span>
                <span>Impuestos: </span>
                <span>{{ pricing.taxes }}</span>
                <span class="lcu-summary-total">Total: </span>
                <span class="lcu-summary-total">{{ pricing.total }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-grid-2">
        <div />
        <div>
          <div class="row">
              <form-field
                :id="'agree-terms'"
                :sideLabel="true"
                :links="[{
                  text: 'Ver términos.',
                  href: '/terminos-de-uso',
                  target: '_blank',
                  rel: 'noopener noreferrer',
                }]"
                :label="TERMS_LABEL">
                <input
                  type="checkbox"
                  name="agree-terms"
                  id="agree-terms"
                  v-model="agreeTerms"
                  class="lcu-form-checkbox" />
              </form-field>
          </div>
          <button-cta
            :text="'PAGAR E INSCRIBIRSE'"
            :type="'secondary'"
            :classes="['full-width-btn']"
            :disabled="!agreeTerms"
            :loading="confirmAndPayLoading"
            @on-click="confirmAndPay" />
        </div>
      </div>
    </div>
    <div v-if="showCompletedEnrollment">
      <div class="row row-center">
        <div class="row row-large">
          <span class="lcu-success-enroll"></span>
        </div>
        <div class="row row-large">
          <span class="lcu-success-msg">
            ¡Felicitaciones! ¡Te has inscrito con éxito en Legacy Christian University!
          </span>
        </div>
        <div class="row">
          <button-cta
            border
            :classes="['lcu-forward-btn']"
            :text="'IR AL PANEL DE CONTROL'"
            @on-click="$router.push({ path: '/panel-de-control' })" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { loadStripe } from '@stripe/stripe-js';
import _ from 'lodash';
import FormField from 'ç/forms/inputs/Field.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import FormValidator from '@/mixins/Validator.vue';
import globalUtils from '@/globals/utils';
import { NOTIFICATION_SUCCESS } from '@/globals/constants';

const TERMS_LABEL = 'Acepto los términos y condiciones de LCU. ';

export default {
  name: 'enrollment-cart',
  mixins: [FormValidator],
  components: {
    ButtonCta,
    SpinLoader,
    'form-field': FormField,
  },
  props: {
    shouldSetupStripe: {
      type: Boolean,
      default: false,
    },
    userProfile: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      TERMS_LABEL,
      validations: {
        name: {
          value: '',
          required: true,
          errors: [],
        },
      },
      showCompletedEnrollment: false,
      agreeTerms: false,
      savePaymentMethod: true,
      discountApplied: false,
      discount: '',
      discountError: false,
      discountLoader: false,
      savings: false,
      initialPricing: {
        subtotal: '—',
        total: '—',
        taxes: '—',
        currency: 'usd',
      },
      pricing: {
        subtotal: '—',
        total: '—',
        taxes: '—',
        currency: 'usd',
      },
      stripe: null,
      stripeLoading: false,
      cardElement: null,
      stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      confirmAndPayLoading: false,
    };
  },
  async mounted() {
    this.$emit('set-signup-error', false);
    await this.getEnrollmentPricing();
    if (this.shouldSetupStripe && !this.cardElement) {
      this.stripeSetup();
    }
  },
  beforeUnmount() {
    if (this.cardElement) {
      this.cardElement.destroy();
    }
  },
  watch: {
    shouldSetupStripe(value) {
      if (value && !this.cardElement) {
        this.stripeSetup();
      }
    },
  },
  methods: {
    async getEnrollmentPricing() {
      try {
        await this.$validateSession();
        const { price } = await this.$students({ method: 'getEnrollmentPricing' });
        this.pricing = price;
        this.initialPricing = _.cloneDeep(price);
      } catch (e) {
        const message = e.message || e;
        this.$emit('set-signup-error', message);
        this.$log.error(message);
      }
    },
    async stripeSetup() {
      try {
        this.stripeLoading = true;
        this.stripe = await loadStripe(this.stripePublishableKey);
        const elements = this.stripe.elements({ locale: 'es' });
        this.cardElement = elements.create('card', globalUtils.stripInputConfig);
        this.cardElement.mount('#card-element');
        this.cardElement.on('change', (event) => {
          const displayError = document.getElementById('card-errors');
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = '';
          }
        });
      } catch (e) {
        const message = e.message || e;
        this.$emit('set-signup-error', message);
        this.$log.error('Stripe setup error: ', message);
      } finally {
        this.stripeLoading = false;
      }
    },
    clearDiscount() {
      this.discountApplied = false;
      this.discount = '';
      this.pricing = _.cloneDeep(this.initialPricing);
      this.savings = false;
      this.$emit('set-signup-error', false);
    },
    async onApplyDiscount() {
      if (this.discountLoader) {
        return;
      }
      this.discountError = false;
      if (this.discount === '') {
        this.discountError = this.formValidationMessages.required;
        return;
      }
      this.discountLoader = true;
      this.discountApplied = false;
      try {
        await this.$validateSession();
        const { USD } = await this.$students({
          method: 'couponCheck',
          payload: {
            productMapId: 'enrollmentFee',
            code: this.discount,
          },
        });
        this.pricing.total = USD.newTotal;
        this.pricing.taxes = USD.newTaxes;
        this.savings = USD.savings;
        this.discountApplied = true;
        this.$emit('set-signup-error', false);
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Código de descuento válido',
          type: 'success',
        });
      } catch (e) {
        const message = e.message || e;
        this.discountError = message;
        this.pricing = _.cloneDeep(this.initialPricing);
        this.$emit('set-signup-error', message);
        this.$log.error(message);
      } finally {
        this.discountLoader = false;
      }
    },
    validateDiscount() {
      if (this.discount === '') {
        this.discountError = this.formValidationMessages.required;
      } else {
        this.discountError = false;
      }
    },
    async confirmAndPay() {
      this.$emit('set-signup-error', false);
      try {
        const validation = this.validate([
          'name',
        ]);
        if (!validation.passed) {
          return;
        }
        this.confirmAndPayLoading = true;
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardElement,
          billing_details: {
            name: `${this.userProfile.firstName} ${this.userProfile.lastName}`,
            email: this.userProfile.email,
          },
        });

        if (error) {
          throw new Error(error.message);
        }

        const { updates } = await this.$students({
          method: 'payAndEnroll',
          payload: {
            discountCode: this.discount,
            paymentMethodId: paymentMethod.id,
            savePaymentMethod: this.savePaymentMethod,
            billingDetails: {
              name: this.validations.name.value,
            },
          },
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.user,
          key: 'fees',
          value: updates.fees,
        });
        this.showCompletedEnrollment = true;
      } catch (e) {
        const message = e.message || e;
        this.$emit('set-signup-error', message);
        this.$log.error(message);
      } finally {
        this.confirmAndPayLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-enroll-inputText {
  background-color: transparent;
  border: 0;
  border-bottom: 2px solid $legacy-primary;
  color: $legacy-primary;
  font-size: 21px;
  padding: 5px;
  width: 100%;

  &:focus-visible {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }

  &:focus {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }

  &:focus-within {
    @include no-focus;
    border-bottom: 2px solid $legacy-primary;
  }
}

.lcu-enroll-errorMsg {
  color: $danger;
  display: inline-block;
  font-size: 16px;
}

.lcu-enroll-inputError {
  background-color: #ffe6e6;
  border-color: $danger;

  &:focus-visible {
    border-color: $danger;
  }

  &:focus {
    border-color: $danger;
  }

  &:focus-within {
    border-color: $danger;
  }
}

.lcu-summary-box {
  padding: 25px 20px;
  border-radius: 3px;
  background-color: $off-white;
}

.lcu-summary-item {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 25px;
}

.lcu-summary-itemImage {
  width: 140px;
  border: 1px solid $gray;
}

.lcu-summary-totals {
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: 30px;
  grid-row-gap: 10px;

  span {
    justify-self: end;
  }
}

.lcu-summary-total {
  font-family: raleway-extra-bold;
  font-size: 18px;
}

.lcu-success-enroll {
  display: inline-block;
  color: $success;
  font-size: 80px;

  &:after {
    font-family: 'lcu';
    content: '\e801';
  }
}

.lcu-success-msg {
  font-size: 24px;
  text-align: center;
  font-family: 'raleway-bold';
}

.lcu-forward-btn {
    &:after {
      display: inline-block;
      font-family: 'lcu';
      content: '\e80a';
      margin-left: 10px;
  }
}

.lcu-form-checkbox {
  background-color: rgba($black, .05);

  &:checked {
    background-color: $legacy-primary;
  }
}

.full-width-btn {
  width: 100%;
}

.lcu-fee-price {
  text-transform: uppercase;
}

.lcu-discount-input {
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-gap: 10px;
  justify-content: end;
  align-items: center;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
}

.lcu-register-inputError {
  background-color: #ffe6e6;
  border-color: $danger;

  &:focus-visible {
    border-color: $danger;
  }

  &:focus {
    border-color: $danger;
  }

  &:focus-within {
    border-color: $danger;
  }
}

.lcu-discount-errorMsg {
  color: $danger;
  display: inline-block;
  font-size: 16px;
}

.lcu-summary-savings {
  color: $success;
  font-weight: bold;
}

.lcu-input-discount {
  color: $legacy-primary;
}

.lcu-disabled-input {
  background-color: $gray-lightest;
  color: #818181;

  &:hover {
    cursor: not-allowed;
  }

  &:focus {
    border-color: transparent;
  }

  &:focus-within {
    border-color: transparent;
  }
}
</style>
